export const isTemplateSaveDisabled = (mode, formValues, formInitialValues) => {
  return mode === 'edit' && isTemplateFormPristine(formValues, formInitialValues)
}

export const isTemplateFormPristine = (formValues, formInitialValues) => {
  return JSON.stringify(formValues) === JSON.stringify(formInitialValues)
}

export const hasDynamicFields = (text) => {
  return /\{\{([^}]+)\}\}/g.test(text)
}

/**
 * Determine which audience filter to apply based on context
 * @param {Object} params - Parameters object
 * @param {string} params.conversationType - Type of conversation (unified_conversation, conversation, amc_conversation, team_conversation)
 * @param {boolean} params.isAmcLender - Whether the user is an AMP lender
 * @param {boolean} params.isAppraiserMessages - Whether this is the Appraiser Messages tab
 * @param {boolean} params.isOrderDetails - Whether this is the Order Details tab (vs MessagesTab)
 * @returns {string|null} - Audience filter value or null for no filter
 */
export const getAudienceFilter = ({
  conversationType,
  isAmcLender,
  isAppraiserMessages = false,
  isOrderDetails = false,
}) => {
  // For AMP users, filter based on context
  if (isAmcLender) {
    if (isAppraiserMessages) {
      return 'amp_and_appraiser'
    }
    // For Order Details tab, show amp_and_lender
    return 'amp_and_lender'
  }

  // Non-AMP users: original logic
  if (conversationType === 'unified_conversation') {
    return null // Show all (everyone and internal)
  }

  // For team_conversation, show internal only
  if (conversationType === 'team_conversation') {
    return 'internal'
  }

  // Order Details tab vs MessagesTab have different defaults
  if (isOrderDetails) {
    return 'everyone' // Order Details: show everyone templates
  }

  return 'internal' // MessagesTab: show internal templates
}

export const getAudienceOptions = (isUsingUnifiedConvo, isAmcLender = false) => {
  // AMP users get AMP-specific audience options
  if (isAmcLender) {
    return [
      { label: 'Vendor (Appraiser Messages Tab)', value: 'amp_and_appraiser' },
      { label: 'Lender (Order Details Tab)', value: 'amp_and_lender' },
    ]
  }

  // Non-AMP users get standard options
  if (isUsingUnifiedConvo) {
    return [
      { label: 'Everyone (Visible to internal users and vendor)', value: 'everyone' },
      { label: 'Internal Only (Visible to internal users only)', value: 'internal' },
    ]
  }

  return [
    { label: 'Everyone (Visible internally in Order Details and to vendor)', value: 'everyone' },
    { label: 'Internal Only (Visible in Team Conversation only)', value: 'internal' },
  ]
}
